var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:{ 'avatar-border': _vm.isBorder },attrs:{"size":_vm.size,"color":"white"}},[(_vm.id)?_c('img',{style:(_vm.style),attrs:{"src":_vm.src}}):_c('span',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }